import { render, staticRenderFns } from "./LockingQuestionModal.vue?vue&type=template&id=5123b103&scoped=true&"
import script from "./LockingQuestionModal.vue?vue&type=script&lang=js&"
export * from "./LockingQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./LockingQuestionModal.vue?vue&type=style&index=0&id=5123b103&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123b103",
  null
  
)

export default component.exports